import { Link, useForm } from "@inertiajs/react";
import type { FormEvent } from "react";

import AuthCard from "@/components/AuthCard";
import Button from "@/components/Button";
import TextField from "@/components/TextField";
import { passwords, sessions } from "@/routes";

export default function PasswordsNew() {
  const form = useForm({ email: "" });

  function submit(e: FormEvent) {
    e.preventDefault();
    form.transform((data) => ({ password: data }));
    form.post(passwords.create().url);
  }

  return (
    <AuthCard
      title="Recuperar contraseña"
      subtitle="Ingresa el correo asociado a tu cuenta y te enviaremos instrucciones para crear una nueva contraseña."
    >
      <form onSubmit={submit} className="mx-auto flex max-w-xl flex-col gap-4">
        <TextField
          name="email"
          type="email"
          placeholder="Correo electrónico"
          autoComplete="email"
          value={form.data.email}
          onChange={(e) => form.setData("email", e.target.value)}
          required
        />

        <Button
          type="submit"
          disabled={form.processing}
          className="mt-2 w-full"
        >
          Enviar instrucciones
        </Button>

        <Link
          href={sessions.new().url}
          className="mt-1 self-center font-sans text-sm text-ink underline underline-offset-2 hover:text-steel"
        >
          Volver a iniciar sesión
        </Link>
      </form>
    </AuthCard>
  );
}
